/* src/app/reports/reports.component.css */
:host ::ng-deep .p-dialog .p-dialog-header .p-dialog-title,
:host ::ng-deep .p-dialog .p-dialog-header .p-dialog-header-title {
  color: #fff !important;
  font-size: 16px !important;
  margin-left: 20px !important;
  font-family: "Roboto" !important;
}
:host ::ng-deep .container {
}
:host ::ng-deep .p-dialog {
  height: auto !important;
}
:host ::ng-deep .p-dialog-content {
  padding-top: 15px !important;
}
:host ::ng-deep .p-dialog-header {
  height: 25px !important;
  background-color: #89bf98 !important;
}
:host ::ng-deep .p-dialog-header {
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}
.col-10,
.col-8,
.col-9 {
  font-size: 14px;
  font-family: "Roboto" !important;
}
.rdtitle .col {
  font-size: 14px !important;
  font-weight: bold;
  color: #89bf98 !important;
  padding-left: 15px !important;
  margin: 0px !important;
  font-family: "Gidole" !important;
}
.row.rdfooter {
  background-color: #89bf98 !important;
  color: white;
  font-family: "Roboto" !important;
  height: 30px;
  margin-top: 20px !important;
  margin-bottom: -33px !important;
  width: 80% !important;
  margin-left: auto;
  margin-right: auto;
}
.col.rdfooter {
  background-color: transparent !important;
  color: white;
}
.col.btn.rdfooter {
  cursor: default !important;
  border: none !important;
}
.col.btn {
  border-left: 1px solid white;
  cursor: pointer;
  font-size: 12px;
}
.col.col-s1 {
  border-right: 1px solid gray;
}
.col.col-s2 {
  padding-left: 30px;
}
hr {
  border-top: 1px solid #8c8b8b;
  border-bottom: 1px solid #fff;
}
.p-dialog .p-dialog-header button {
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}
/*# sourceMappingURL=reports.component.css.map */
